import { RichEmptyState, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { MailBoxImage } from '../../Images/MailboxImage';
import { NoMailEmptyStateType } from './EmptyStatesTypes';

function NoMailEmptyState(props: NoMailEmptyStateType) {
	const { t } = useTranslation();

	return (
		<RichEmptyState
			key={`noMailEmptyState_${props.keySlug}NoItems`}
			title={t('mailboxes.noData.title', { folder: props.mailBoxInfo.folderName })}
			description={
				props.mailBoxInfo.folderId === 1
					? t('mailboxes.noDataInbox.description')
					: props.mailBoxInfo.customFolderId
						? t('mailboxes.noDataCustomFolder.description')
						: t('mailboxes.noData.description')
			}
			media={<MailBoxImage />}
		/>
	);
}

export { NoMailEmptyState };
